// extracted by mini-css-extract-plugin
export default {"container":"container__V0Fig","main":"main__CGdXa","head":"head__2q7oF","subtitle":"subtitle__OfuEx","icon":"icon__RVaO6"};